import { Box, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        border-radius: 16px;
`
);

const LogoSignWrapper = styled(Box)(
  () => `
        width: 165px;
        height: 45px;
        transform:scale(0.6)
`
);

const LogoSign = styled(Box)(
  ({ theme }) => `
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto ${theme.spacing(2)};

    

`
);

const LogoTextWrapper = styled(Box)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-bottom: ${theme.spacing(5)};
`
);

const LogoText = styled(Box)(
  ({ theme }) => `
        font-size: ${theme.typography.pxToRem(15)};
        font-weight: ${theme.typography.fontWeightBold};
`
);

// The header version badge is rendered as a real <button> so users can
// click it to re-open the release notes modal at any time. The
// `ReleaseNotesGate` mounted in `App.jsx` listens for this custom event
// and surfaces the modal regardless of which page is active.
const VersionBadge = styled("button")(
  ({ theme }) => `
        background: ${theme.palette.mode === "light" ? "rgba(226, 232, 240, 0.92)" : "rgba(30, 41, 59, 0.92)"};
        color: ${theme.palette.mode === "light" ? "#334155" : "#e2e8f0"};
        border: 1px solid ${theme.palette.mode === "light" ? "rgba(148, 163, 184, 0.32)" : "rgba(148, 163, 184, 0.18)"};
        padding: ${theme.spacing(0.4, 1)};
        border-radius: ${theme.general.borderRadiusSm};
        text-align: center;
        display: inline-block;
        line-height: 1;
        font-size: ${theme.typography.pxToRem(11)};
        font-weight: 700;
        letter-spacing: 0.02em;
        white-space: nowrap;
        cursor: pointer;
        font-family: inherit;
        transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.05s ease;
        &:hover {
          background: ${theme.palette.mode === "light" ? "rgba(203, 213, 225, 0.95)" : "rgba(51, 65, 85, 0.95)"};
          border-color: ${theme.palette.mode === "light" ? "rgba(100, 116, 139, 0.45)" : "rgba(148, 163, 184, 0.32)"};
        }
        &:active {
          transform: translateY(1px);
        }
        &:focus-visible {
          outline: 2px solid ${theme.palette.primary.main};
          outline-offset: 2px;
        }
  `
);

export const APP_VERSION = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";

function openReleaseNotes() {
  // The global `ReleaseNotesGate` listens for this event and opens the
  // modal without changing the persisted last-seen-release marker. That
  // means re-opening from the header is non-destructive: it doesn't reset
  // the seen flag for users who have already dismissed the latest entry.
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("netbase:showReleaseNotes"));
}

export function Version({ sx }) {
  return (
    <Tooltip arrow title="View release notes">
      <VersionBadge
        type="button"
        onClick={openReleaseNotes}
        aria-label={`View release notes for v${APP_VERSION}`}
        sx={sx}
      >
        v{APP_VERSION}
      </VersionBadge>
    </Tooltip>
  );
}



// the logo now routes users back into the app root instead of
// navigating away to the marketing site. Previously clicking the logo would
// drop users out of their session on netbaseapp.com.
export function Logo() {
  return (
    <LogoWrapper to="/" aria-label="NetBase home">
      <LogoSignWrapper>
        <LogoSign>
          <img alt="NetBase logo" src="/static/images/logo/logo.svg" style={{ width: '260px', height: '50px' }} />
        </LogoSign>
      </LogoSignWrapper>
    </LogoWrapper>
  );
}

export function LogoAlone() {
  return (
    <LogoSign>
      <img alt="Site logo" src="/static/images/logo/logo.svg" style={{ width: '50px', height: '50px' }} />
    </LogoSign>
  );
}
